import { useMemo } from 'react';
import { SUPER_STAKE_ACCOUNT_NAMES } from 'src/constants/constants';
import useDriftAccountStore, {
	AccountData,
} from 'src/stores/useDriftAccountsStore';
import { ZERO } from '@velocity-exchange/sdk';
import { useAllAccountsMarginInfo } from 'src/hooks/query/accountTradingData/useMarginInfo';

/**
 * Checks if the current authority has a SSS account
 */
export const useHasActiveSSSAccount = () => {
	const accounts = useDriftAccountStore((s) => s.accounts);

	const sssAccounts = useMemo(
		() =>
			Object.values(accounts)
				.filter((acc): acc is AccountData => !!acc)
				.filter((account) => SUPER_STAKE_ACCOUNT_NAMES.includes(account.name)),
		[accounts]
	);

	const { data: allMarginInfos } = useAllAccountsMarginInfo();

	const hasActiveSSSAccount = useMemo(
		() =>
			sssAccounts.some((acc) => {
				const marginInfo = allMarginInfos?.[acc.userKey];
				return marginInfo && marginInfo.netUsdValue.gt(ZERO);
			}),
		[sssAccounts, allMarginInfos]
	);

	return hasActiveSSSAccount;
};
